import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { StatCard, money } from "../office/ui";

const MLM_STATS = [
  ["distributors_total", "Distribuidores registrados", true],
  ["distributors_active", "Con membresía pagada"],
  ["distributors_pending", "Pendientes de pago"],
  ["payments_pending_review", "Comprobantes por revisar"],
  ["membership_revenue", "Ingreso por membresías", false, money],
  ["commissions_paid", "Comisiones pagadas", false, money],
  ["commissions_pending", "Comisiones por pagar", false, money],
  ["payments_approved", "Pagos aprobados"],
];

const SITE_STATS = [
  ["leads_total", "Interesados (formulario)"],
  ["leads_week", "Interesados últimos 7 días"],
  ["services_active", "Servicios activos"],
  ["faqs", "Preguntas frecuentes"],
];

export const Overview = ({ goTo }) => {
  const [mlm, setMlm] = useState(null);
  const [site, setSite] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/admin/mlm/stats").then(({ data }) => alive && setMlm(data)).catch(() => alive && setMlm({}));
    api.get("/admin/stats").then(({ data }) => alive && setSite(data)).catch(() => alive && setSite({}));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div data-testid="overview-panel">
      <h2 className="font-display text-3xl font-semibold tracking-tight">Resumen</h2>
      <p className="mt-1 text-sm text-ink/70">Red comercial, membresías y comisiones.</p>
      <div className="mt-6 grid grid-cols-2 gap-3 lg:grid-cols-4">
        {MLM_STATS.map(([k, label, dark, fmt]) => (
          <StatCard key={k} dark={dark} label={label} value={mlm ? (fmt ? fmt(mlm[k]) : mlm[k] ?? 0) : "…"} testId={`stat-${k}`} />
        ))}
      </div>
      {mlm?.payments_pending_review > 0 && (
        <button onClick={() => goTo("pagos")} className="mt-4 w-full rounded-2xl border border-sun/60 bg-sun/15 px-5 py-4 text-left text-sm font-semibold hover:bg-sun/25" data-testid="overview-pending-payments">
          Tienes {mlm.payments_pending_review} comprobante(s) de pago por revisar →
        </button>
      )}
      <h3 className="mt-10 font-display text-xl font-semibold tracking-tight">Sitio web</h3>
      <div className="mt-4 grid grid-cols-2 gap-3 lg:grid-cols-4">
        {SITE_STATS.map(([k, label]) => <StatCard key={k} label={label} value={site ? site[k] ?? 0 : "…"} testId={`stat-${k}`} />)}
      </div>
    </div>
  );
};
